import { render, staticRenderFns } from "./ResponseTemplatesFormModal.vue?vue&type=template&id=8dd71a56&"
import script from "./ResponseTemplatesFormModal.vue?vue&type=script&lang=js&"
export * from "./ResponseTemplatesFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports